"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DK;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/web.dom.iterable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var divDom = document.createElement('div');

function query(selector) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var maybeID = selector[0] === '#';
  var maybeClass = !maybeID && selector[0] === '.';
  var nameOnly = maybeID || maybeClass ? selector.slice(1) : selector;
  var simpleSelectorRE = /^[\w-]*$/;
  var isSimple = simpleSelectorRE.test(nameOnly);
  var el = [];

  if (maybeID && isSimple && element.getElementById) {
    var found = element.getElementById(nameOnly);

    if (found) {
      el = [found];
    }
  } else if ([1, 9, 11].indexOf(element.nodeType) !== -1) {
    if (!maybeID && isSimple && element.getElementsByClassName) {
      if (maybeClass) {
        el = element.getElementsByClassName(nameOnly);
      } else {
        el = element.getElementsByTagName(selector);
      }
    } else {
      el = element.querySelectorAll(selector);
    }
  }

  return Array.prototype.slice.call(el);
}

var D =
/*#__PURE__*/
function () {
  function D() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, D);

    this.el = el;
  }

  _createClass(D, [{
    key: "html",
    value: function html() {
      var _html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.el.forEach(function (item) {
        item.innerHTML = _html;
      });
    }
  }, {
    key: "val",
    value: function val() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.el.forEach(function (item) {
        item.value = value;
      });
    }
  }, {
    key: "append",
    value: function append() {
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      divDom.innerHTML = html;
      var htmlDom = divDom.childNodes[0];
      this.el.forEach(function (item) {
        item.appendChild(htmlDom);
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.el.forEach(function (item) {
        if (item.style.display !== 'block') {
          item.style.display = 'block';
        }
      });
      return this;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.el.forEach(function (item) {
        if (item.style.display !== 'none') {
          item.style.display = 'none';
        }
      });
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      this.el.forEach(function (item) {
        item.remove();
      });
    }
  }, {
    key: "find",
    value: function find(selector) {
      var child = [];
      this.el.forEach(function (item) {
        child = child.concat(query(selector, item));
      });
      return new D(child);
    }
  }, {
    key: "hasClass",
    value: function hasClass() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.el;
      var flag = false;

      for (var i = 0; i < el.length; i += 1) {
        var reg = new RegExp("(^|\\s)".concat(className, "(\\s|$)"));

        if (reg.test(el[i].className)) {
          flag = true;
          break;
        }
      }

      return flag;
    }
  }, {
    key: "addClass",
    value: function addClass() {
      var _this = this;

      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.el.forEach(function (item) {
        if (!_this.hasClass(className, [item])) {
          var newClass = item.className.split(' ');
          newClass.push(className);
          item.className = newClass.join(' ');
        }
      });
    }
  }, {
    key: "removeClass",
    value: function removeClass() {
      var _this2 = this;

      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.el.forEach(function (item) {
        if (_this2.hasClass(className, [item])) {
          var reg = new RegExp("(^|\\s)".concat(className, "(\\s|$)"), 'g');
          item.className = item.className.replace(reg, ' ');
        }
      });
    }
  }, {
    key: "on",
    value: function on() {
      var _this3 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';
      var selectorOrFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var fnOrUseCapture = arguments.length > 2 ? arguments[2] : undefined;
      var useCapture = arguments.length > 3 ? arguments[3] : undefined;

      if (typeof selectorOrFn === 'string') {
        this.el.forEach(function (item) {
          item.addEventListener(event, function (e) {
            var maybeID = selectorOrFn[0] === '#';
            var maybeClass = !maybeID && selectorOrFn[0] === '.';
            var nameOnly = maybeID || maybeClass ? selectorOrFn.slice(1) : selectorOrFn;
            var target = e.target;

            while (target !== item) {
              if (maybeID && target.id === nameOnly || maybeClass && _this3.hasClass(nameOnly, [target]) || target.tagName.toLowerCase() === nameOnly) {
                fnOrUseCapture(e, target);
                break;
              }

              target = target.parentNode;
            }
          }, !!useCapture);
        });
      } else {
        this.el.forEach(function (item) {
          item.addEventListener(event, selectorOrFn, !!fnOrUseCapture);
        });
      }
    }
  }, {
    key: "width",
    value: function width(value) {
      var result = value;
      this.el.forEach(function (item) {
        if (value) {
          item.style.width = "".concat(value, "px");
        } else {
          result = item.clientWidth;
        }
      });
      return result;
    }
  }, {
    key: "height",
    value: function height(value) {
      var result = value;
      this.el.forEach(function (item) {
        if (value) {
          item.style.height = "".concat(value, "px");
        } else {
          result = item.clientHeight;
        }
      });
      return result;
    }
  }]);

  return D;
}();
/**
 * dom操作，类似zepto
 * 参数：
 *  {
 *    selector：{String} 选择器，id、className、tagName
 *    element：{String} 元素，默认document
 *  }
 *  方法：
 *    html：更新内容
 *    append：元素内部最后插入内容
 *    show：显示
 *    hide：隐藏
 *    remove：销毁
 *    find：查找子元素
 *      {
 *        selector：{String} 选择器，id、className、tagName
 *      }
 *    hasClass：是否有className
 *      {
 *        className：{String} 选择器，id、className、tagName
 *      }
 *    addClass：增加className
 *      {
 *        className：{String} 选择器，id、className、tagName
 *      }
 *    removeClass：去除className
 *      {
 *        className：{String} 选择器，id、className、tagName
 *      }
 *    on：绑定事件
 *      {
 *        event：{String} 事件类型
 *        selectorOrFn：{String/Function} 选择器或者事件回调，选择器是事件代理
 *        fnOrUseCapture：{Function/Boolean} 事件回调或者事件捕获设置
 *        useCapture：{Boolean} 事件捕获设置
 *      }
 */


function DK(selector, element) {
  if (selector instanceof D) {
    return selector;
  }

  var el = query(selector, element);
  return new D(el);
}